<div class="form-wrapper">
  <!-- Loading Overlay -->
  <div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner-box">
      <div class="circle-border">
        <div class="circle-core"></div>
      </div>
      <!-- <div class="spinner-text">{{ spinnerText }}</div> -->
    </div>
  </div>

  <!-- Header -->
  <div class="header">
    <button type="button" class="back-btn" (click)="goBack()" [disabled]="stepHistory.length === 0 || submitted">
      Back
    </button>
    <div class="logo-container">
      <h1 class="logo">KnockVia</h1>
    </div>
  </div>

  <!-- Progress Bar -->
  <div class="progress-bar-container">
    <div class="progress-bar" [style.width.%]="progressPercentage"></div>
  </div>

  <!-- Main Content -->
  <div class="form-card">
    <div class="step-container" [@slideAnimation]="currentStep">
      <ng-container [ngSwitch]="currentStep">

        <!-- LEAD INFO STEP -->
        <div *ngSwitchCase="'leadinfo'" class="step-content">
          <section class="hero">
            <h1>Check availability</h1>
            <p>Enter the service address to see what's available.</p>
          </section>

          <!-- Pre-order iframe -->
          <!-- <div *ngIf="showPreOrderIframe && preOrderUrl" class="preorder-iframe-container">
            <iframe [src]="preOrderUrl" style="width: 100%; height: 100vh; border: none;"></iframe>
          </div> -->

          <!-- Address Form -->
          <div *ngIf="showForm && !showPreOrderIframe" class="form-section">
            <form [formGroup]="addressForm" (ngSubmit)="submitAddress()" novalidate>
              <div class="form-group">
                <label>Location Type</label>
                <div class="segment-group">
                  <label class="segment-option">
                    <input type="radio" formControlName="locationType" value="Residential" />
                    <span>Residential</span>
                  </label>
                  <label class="segment-option">
                    <input type="radio" formControlName="locationType" value="Business" />
                    <span>Business</span>
                  </label>
                </div>
              </div>

              <div class="form-group autocomplete-wrapper">
                <label for="address">Address</label>
                <input #addressInput type="text" id="address" formControlName="address" placeholder="Enter address"
                  class="form-input" autocomplete="street-address" />
                <small class="helper-text">Don't include apartment/unit (you can pick it on the next step).</small>

                <!-- Suggestions dropdown -->
                <div class="suggestions" *ngIf="suggestions?.length">
                  <ul class="suggestion-list">
                    <li *ngFor="let suggestion of suggestions" (click)="selectSuggestion(suggestion)"
                      class="suggestion-item">
                      <span class="suggestion-icon">📍</span>
                      <span class="suggestion-text">{{ suggestion.address }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <input type="text" formControlName="honeypot" class="honeypot-input" autocomplete="off" tabindex="-1"
                aria-hidden="true" />

              <button type="submit" class="btn btn-primary" [disabled]="addressForm.invalid || isLoading">
                Find Address
              </button>
            </form>
          </div>

          <!-- Address List -->
          <div *ngIf="showAddressList && !showPreOrderIframe" class="address-list-section">
            <h2 *ngIf="eligibleAddresses?.length > 0">Please confirm address</h2>
            <h2 *ngIf="eligibleAddresses?.length === 0">No addresses found</h2>

            <div *ngIf="eligibleAddresses?.length === 0">
              <p class="error-text">Try simplifying (no unit #) or check spelling.</p>
              <button type="button" class="btn btn-secondary"
                (click)="showForm = true; showAddressList = false">Back</button>
            </div>

            <div *ngIf="eligibleAddresses?.length > 0">
              <ul class="address-list">
                <li *ngFor="let a of eligibleAddresses; let i = index" (click)="selectAddress(i, a)"
                  [class.selected]="i === selectedAddressIndex" class="address-item">
                  <label>
                    <input type="radio" [value]="i" [checked]="i === selectedAddressIndex" />
                    <div class="address-details">
                      <div class="addr-line">{{ a.address }}</div>
                      <div *ngIf="a.unit" class="addr-meta">Unit: {{ a.unit }}</div>
                    </div>
                  </label>
                </li>
              </ul>

              <button type="button" class="btn btn-primary" [disabled]="selectedAddressIndex === null"
                (click)="confirmAddress()">
                Confirm Address
              </button>
              <button type="button" class="btn btn-secondary"
                (click)="showForm = true; showAddressList = false">Back</button>
            </div>
          </div>
        </div>

        <!-- PLANS STEP -->
        <div *ngSwitchCase="'plans'" class="step-content">
          <section class="hero">
            <h1>Choose your plan</h1>
            <p>Select an internet plan and any add-ons.</p>
          </section>

          <div class="form-section">
            <div class="form-group">
              <label>Please select a plan</label>
              <select class="form-select" [(ngModel)]="selectedPlanIndex"
                (change)="setCheckBoxValInternet($any($event.target).value)">
                <option [value]="null">Select a plan</option>
                <option *ngFor="let p of plansList; let i = index" [value]="i">
                  {{ p.internet?.productName || p.PlanName }} — {{ (p.internet?.productPriceCalculated ||
                  p.recurringAmount) | currency }}
                </option>
              </select>
            </div>

            <ng-container *ngIf="selectedInternet">
              <div class="section-header">
                <h3>Included and optional equipment</h3>
              </div>

              <div *ngIf="hasEquipmentOptions && !isEquipmentValid" class="error-message">
                Please select either the gateway or use your own equipment.
              </div>

              <div class="form-group checkbox-group" *ngIf="selectedInternet?.wifiGateway">
                <label>
                  <input type="checkbox" [checked]="selectedGateway === selectedInternet.wifiGateway"
                    (change)="setCheckBoxValGateway($event)" [disabled]="ownEquipment" />
                  <span>
                    {{ selectedInternet.wifiGateway.productName }}
                    — {{ calculatePriceGeneric(selectedInternet.wifiGateway).isIncluded ? 'Included' :
                    (selectedInternet.wifiGateway.productPrice | currency) }}
                  </span>
                </label>
              </div>

              <div class="form-group checkbox-group" *ngIf="selectedInternet?.useMyOwnEquipment">
                <label>
                  <input type="checkbox" [checked]="ownEquipment === selectedInternet.useMyOwnEquipment"
                    (change)="setCheckBoxValOwn($event)" />
                  <span>
                    {{ selectedInternet.useMyOwnEquipment.productName }}
                    — {{ selectedInternet.useMyOwnEquipment.productPrice | currency }}
                  </span>
                </label>
              </div>

              <div class="form-group checkbox-group" *ngIf="selectedInternet?.wifiExtenders">
                <label>
                  <input type="checkbox" [checked]="selectedExtender === selectedInternet.wifiExtenders"
                    (change)="setCheckBoxValExtender($event)" [disabled]="!selectedGateway || ownEquipment" />
                  <span>
                    {{ selectedInternet.wifiExtenders.productName }}
                    — {{ calculatePriceGeneric(selectedInternet.wifiExtenders).isIncluded ? 'Included' :
                    (selectedInternet.wifiExtenders.productPrice | currency) }}
                  </span>
                </label>
              </div>

              <div class="form-group checkbox-group"
                *ngIf="selectedInternet?.staticIpAddress && selectedInternet?.businessVoipUnlimited">
                <label>
                  <input type="checkbox" [checked]="selectedStaticIp === selectedInternet.staticIpAddress"
                    (change)="setCheckBoxValStaticIp($event)" [disabled]="!selectedGateway || ownEquipment" />
                  <span>
                    {{ selectedInternet.staticIpAddress.productName }}
                    — {{ selectedInternet.staticIpAddress.productPrice | currency }}
                  </span>
                </label>
              </div>

              <!-- Home Phone Section -->
              <div *ngIf="!selectedInternet?.businessVoipUnlimited" class="section-header">
                <h3>Home Phone</h3>
              </div>

              <div class="form-group checkbox-group" *ngIf="!selectedInternet?.businessVoipUnlimited">
                <label>
                  <input type="checkbox" [checked]="!!selectedPhone"
                    (change)="togglePhoneSelection($event.target.checked)" />
                  <span>Include Home phone</span>
                </label>
              </div>

              <ng-container *ngIf="selectedPhone && !selectedInternet?.businessVoipUnlimited">
                <div class="form-group radio-group">
                  <label *ngIf="selectedInternet?.homePhonePlus">
                    <input type="radio" name="phonePlan" value="homePhonePlus"
                      [checked]="selectedPhone === selectedInternet.homePhonePlus" />
                    <span>VoIP Unlimited Plus — {{ selectedInternet.homePhonePlus.productPrice | currency }} (Includes
                      Battery Backup)</span>
                  </label>
                  <label *ngIf="selectedInternet?.homePhone">
                    <input type="radio" name="phonePlan" value="homePhone"
                      [checked]="selectedPhone === selectedInternet.homePhone" />
                    <span>VoIP Unlimited — {{ selectedInternet.homePhone.productPrice | currency }}</span>
                  </label>
                </div>
              </ng-container>

              <div class="form-group checkbox-group"
                *ngIf="(selectedPhone || selectedBusinessPhone) && selectedInternet?.monitoredBatteryBackup && selectedPhone !== selectedInternet?.homePhonePlus">
                <label>
                  <input type="checkbox" [checked]="selectedBattery === selectedInternet.monitoredBatteryBackup"
                    (change)="setCheckBoxValBattery($event)" />
                  <span>
                    {{ selectedInternet.monitoredBatteryBackup.productName }}
                    — {{ selectedInternet.monitoredBatteryBackup.productPrice | currency }}
                  </span>
                </label>
              </div>

              <!-- Phone Number Options -->
              <div *ngIf="selectedPhone" class="section-header">
                <h3>Phone number options</h3>
              </div>

              <div *ngIf="selectedPhone" class="form-group radio-group">
                <label>
                  <input type="radio" name="phoneOption" value="new" [checked]="phoneNumberOption === 'new'"
                    (change)="onPhoneNumberOptionChange('new')" />
                  <span>Assign new number</span>
                </label>
                <!-- <label *ngIf="conversionPhone">
                  <input type="radio" name="phoneOption" value="keep_cci" [checked]="phoneNumberOption === 'keep_cci'"
                    (change)="onPhoneNumberOptionChange('keep_cci')" />
                  <span>Keep existing Consolidated number: {{ conversionPhone.id }}</span>
                </label> -->
                <label>
                  <input type="radio" name="phoneOption" value="port_other"
                    [checked]="phoneNumberOption === 'port_other'" (change)="onPhoneNumberOptionChange('port_other')" />
                  <span>Keep number from another carrier</span>
                </label>
              </div>

              <!-- Business Phone Section -->
              <div *ngIf="selectedInternet?.businessVoipUnlimited" class="section-header">
                <h3>Business Phone</h3>
              </div>

              <div class="form-group checkbox-group" *ngIf="selectedInternet?.businessVoipUnlimited">
                <label>
                  <input type="checkbox" [checked]="selectedBusinessPhone === selectedInternet.businessVoipUnlimited"
                    (change)="toggleBusinessPhoneSelection($event.target.checked, 1)" />
                  <span>{{ selectedInternet.businessVoipUnlimited.productName }}</span>
                </label>
              </div>

              <div *ngIf="selectedBusinessPhone" class="form-group radio-group">
                <label>
                  <input type="radio" name="businessLine1" value="new" [checked]="businessLine1Flag === 'new'"
                    (change)="onBusinessLine1OptionChange('new')" />
                  <span>Assign new number</span>
                </label>
                <label *ngIf="conversionPhone">
                  <input type="radio" name="businessLine1" value="consolidated"
                    [checked]="businessLine1Flag === 'consolidated'"
                    (change)="onBusinessLine1OptionChange('consolidated')" />
                  <span>Keep existing Consolidated number: {{ conversionPhone.id }}</span>
                </label>
                <label>
                  <input type="radio" name="businessLine1" value="other" [checked]="businessLine1Flag === 'other'"
                    (change)="onBusinessLine1OptionChange('other')" />
                  <span>Keep number from another carrier</span>
                </label>
              </div>

              <div *ngIf="selectedBusinessPhone && selectedInternet?.businessVoipUnlimited"
                class="form-group checkbox-group">
                <label>
                  <input type="checkbox" [checked]="!!selectedBusinessPhone2"
                    (change)="toggleBusinessPhoneSelection($event.target.checked, 2)" />
                  <span>Business Line 2 — {{ 20 | currency }}</span>
                </label>
              </div>

              <div *ngIf="selectedBusinessPhone2" class="form-group radio-group">
                <label>
                  <input type="radio" name="businessLine2" value="new" [checked]="businessLine2Flag === 'new'"
                    (change)="onBusinessLine2OptionChange('new')" />
                  <span>Assign new number</span>
                </label>
                <label *ngIf="conversionPhone">
                  <input type="radio" name="businessLine2" value="consolidated"
                    [checked]="businessLine2Flag === 'consolidated'"
                    (change)="onBusinessLine2OptionChange('consolidated')" />
                  <span>Keep existing Consolidated number: {{ conversionPhone.id }}</span>
                </label>
                <label>
                  <input type="radio" name="businessLine2" value="other" [checked]="businessLine2Flag === 'other'"
                    (change)="onBusinessLine2OptionChange('other')" />
                  <span>Keep number from another carrier</span>
                </label>
              </div>
            </ng-container>

            <div class="actions">
              <button type="button" class="btn btn-primary" [disabled]="hideButton" (click)="submitPlans()">
                Next step
              </button>
            </div>
          </div>
        </div>

        <!-- CARRIERS STEP -->
        <div *ngSwitchCase="'carriers'" class="step-content">
          <section class="hero">
            <h1>Number transfer</h1>
            <p>Send LOA details and enter porting info for each selected line.</p>
          </section>

          <div class="form-section">
            <!-- Contact Form -->
            <form *ngIf="contactForm" [formGroup]="contactForm" novalidate>
              <div class="section-header">
                <h3>Authorization contact</h3>
              </div>

              <div class="form-group">
                <label>Phone for LOA text *</label>
                <input type="tel" formControlName="phone" class="form-input" maxlength="10" />
                <small class="error-text"
                  *ngIf="contactForm.get('phone')?.touched && contactForm.get('phone')?.invalid">
                  <span *ngIf="contactForm.get('phone')?.errors?.['required']">Phone is required.</span>
                  <span *ngIf="contactForm.get('phone')?.errors?.['pattern']">Enter a 10-digit number.</span>
                </small>
              </div>

              <div class="form-group">
                <label>Email for LOA *</label>
                <input type="email" formControlName="email" class="form-input" />
                <small class="error-text"
                  *ngIf="contactForm.get('email')?.touched && contactForm.get('email')?.invalid">
                  <span *ngIf="contactForm.get('email')?.errors?.['required']">Email is required.</span>
                  <span *ngIf="contactForm.get('email')?.errors?.['email']">Enter a valid email.</span>
                </small>
              </div>
            </form>

            <!-- Porting Lines Forms -->
            <ng-container *ngFor="let line of portingLines; let i = index">
              <form *ngIf="forms?.[i]" [formGroup]="forms[i]" novalidate>
                <div class="section-header">
                  <h3>{{ line.label }}</h3>
                </div>

                <div class="form-group">
                  <label>Phone number to port *</label>
                  <input type="tel" formControlName="phonePortNum" class="form-input" maxlength="10" />
                  <small class="error-text"
                    *ngIf="forms[i].get('phonePortNum')?.touched && forms[i].get('phonePortNum')?.invalid">
                    <span *ngIf="forms[i].get('phonePortNum')?.errors?.['required']">Number to port is required.</span>
                    <span *ngIf="forms[i].get('phonePortNum')?.errors?.['pattern']">Enter a 10-digit number.</span>
                    <span
                      *ngIf="forms[i].get('phonePortNum')?.errors?.['areaCodeNotAllowed'] && allowedPortAreaCodes.length">
                      Only area codes {{ allowedPortAreaCodes.join(', ') }} are eligible.
                    </span>
                    <span *ngIf="forms[i].get('phonePortNum')?.errors?.['duplicatePortNumber']">
                      This number matches another line.
                    </span>
                  </small>
                </div>

                <div class="form-group">
                  <label>Current account number (existing provider) *</label>
                  <input type="text" formControlName="accountNum" class="form-input" maxlength="50" />
                </div>

                <div class="form-group">
                  <label>Name on account *</label>
                  <input type="text" formControlName="accountName" class="form-input" />
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Caller ID first name *</label>
                    <input type="text" formControlName="callerFirst" class="form-input" />
                  </div>
                  <div class="form-group">
                    <label>Caller ID last name *</label>
                    <input type="text" formControlName="callerLast" class="form-input" maxlength="13" />
                  </div>
                </div>

                <small class="helper-text">
                  Caller ID preview: {{ (forms[i].get('callerFirst')?.value || '') | slice:0:1 }},{{
                  (forms[i].get('callerLast')?.value || '') | slice:0:13 }}
                </small>

                <div class="section-header">
                  <h3>Billing address on existing provider</h3>
                </div>

                <div class="form-group">
                  <label>Address line 1 *</label>
                  <input type="text" formControlName="address" class="form-input" />
                </div>

                <div class="form-group">
                  <label>Address line 2</label>
                  <input type="text" formControlName="address2" class="form-input" />
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>City *</label>
                    <input type="text" formControlName="city" class="form-input" />
                  </div>
                  <div class="form-group">
                    <label>State *</label>
                    <select formControlName="state" class="form-select">
                      <option value="">Select state</option>
                      <option *ngFor="let state of states" [value]="state.abbr">{{ state.name }} – {{ state.abbr }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>ZIP *</label>
                    <input type="text" formControlName="zip" class="form-input" maxlength="10" />
                  </div>
                </div>

                <div class="form-group">
                  <label>Transfer PIN (if required)</label>
                  <input type="text" formControlName="transferPin" class="form-input" maxlength="10" />
                </div>

                <div class="actions" *ngIf="i === forms.length - 1">
                  <button type="button" class="btn btn-primary"
                    [disabled]="forms[i].invalid || contactForm.invalid || hasDuplicatePortNumbers || isLoading"
                    (click)="submitPort(i)">
                    Next step
                  </button>
                </div>
              </form>
            </ng-container>

            <!-- LOA Only Path -->
            <div *ngIf="portingLines.length === 0 && needsLoaOnly" class="actions">
              <button type="button" class="btn btn-primary" [disabled]="contactForm.invalid || isLoading"
                (click)="getLoa()">
                Send LOA
              </button>
            </div>
          </div>

          <!-- LOA Modal -->
          <div *ngIf="modalOpen" class="modal-backdrop" (click)="modalOpen = false">
            <div class="modal" (click)="$event.stopPropagation()">
              <div class="modal-header">
                <h2>Letter of Authorization</h2>
                <button type="button" class="modal-close" (click)="modalOpen = false">&times;</button>
              </div>
              <div class="modal-body">
                <h3>LOA required to port the number</h3>
                <p *ngIf="!error">{{ displayText }}</p>
                <p *ngIf="error" class="error-text">{{ errorText }}</p>

                <div class="button-group">
                  <button type="button" class="btn btn-primary" [disabled]="contactForm.get('email')?.invalid"
                    (click)="sendLoaMessage('SendEmail')">
                    Send link by email
                  </button>
                  <button type="button" class="btn btn-primary" [disabled]="contactForm.get('phone')?.invalid"
                    (click)="sendLoaMessage('SendSms')">
                    Send link by text
                  </button>
                </div>

                <button type="button" class="btn btn-success" (click)="getLoa()">
                  Verify LOA
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ADDRESS CHECK (CUSTOMER INFO) STEP -->
        <div *ngSwitchCase="'address'" class="step-content">
          <section class="hero">
            <h1>Confirm your details</h1>
            <p>Please enter your details to continue with your order.</p>
          </section>

          <div class="form-section">
            <form [formGroup]="customerInfoForm" (ngSubmit)="checkEmail()" novalidate>
              <div class="section-header">
                <h3>Customer</h3>
              </div>

              <div class="form-group" *ngIf="isBusiness">
                <label>Business Name *</label>
                <input type="text" formControlName="businessName" class="form-input" maxlength="50" />
                <small class="error-text"
                  *ngIf="customerInfoForm.get('businessName')?.touched && customerInfoForm.get('businessName')?.invalid">
                  Business name is required.
                </small>
              </div>

              <div class="form-group">
                <label>First Name *</label>
                <input type="text" formControlName="first" class="form-input" maxlength="20" />
                <small class="error-text"
                  *ngIf="customerInfoForm.get('first')?.touched && customerInfoForm.get('first')?.invalid">
                  First name is required.
                </small>
              </div>

              <div class="form-group">
                <label>Last Name *</label>
                <input type="text" formControlName="last" class="form-input" maxlength="50" />
                <small class="error-text"
                  *ngIf="customerInfoForm.get('last')?.touched && customerInfoForm.get('last')?.invalid">
                  Last name is required.
                </small>
              </div>

              <div class="form-group">
                <label>Cell Phone *</label>
                <input type="tel" formControlName="phone" class="form-input" maxlength="10" />
                <small class="error-text"
                  *ngIf="customerInfoForm.get('phone')?.touched && customerInfoForm.get('phone')?.invalid">
                  <span *ngIf="customerInfoForm.get('phone')?.errors?.['required']">Phone is required.</span>
                  <span *ngIf="customerInfoForm.get('phone')?.errors?.['number']">Digits only.</span>
                  <span *ngIf="customerInfoForm.get('phone')?.errors?.['minlength']">Must be 10 digits.</span>
                </small>
              </div>

              <div class="form-group">
                <label>Email *</label>
                <input type="email" formControlName="email" class="form-input" maxlength="50" />
                <small class="error-text"
                  *ngIf="customerInfoForm.get('email')?.touched && customerInfoForm.get('email')?.invalid">
                  <span *ngIf="customerInfoForm.get('email')?.errors?.['required']">Email is required.</span>
                  <span *ngIf="customerInfoForm.get('email')?.errors?.['email']">Enter a valid email.</span>
                </small>
              </div>

              <div class="section-header">
                <h3>Service address</h3>
              </div>

              <div class="form-group">
                <label>Address</label>
                <input type="text" [value]="fullData?.addressInfo?.address1" class="form-input" disabled />
              </div>

              <div class="form-group">
                <label>Line 2</label>
                <input type="text" [value]="fullData?.addressInfo?.address2" class="form-input" disabled />
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>City</label>
                  <input type="text" [value]="fullData?.addressInfo?.city" class="form-input" disabled />
                </div>
                <div class="form-group">
                  <label>State</label>
                  <select [value]="fullData?.addressInfo?.state" class="form-select" disabled>
                    <option *ngFor="let state of states" [value]="state.abbr">{{ state.name }} – {{ state.abbr }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>ZIP</label>
                  <input type="text" [value]="fullData?.addressInfo?.zip" class="form-input" maxlength="10" disabled />
                </div>
              </div>

              <div class="section-header">
                <h3>Billing address</h3>
              </div>

              <div class="form-group checkbox-group">
                <label>
                  <input type="checkbox" formControlName="billingCheckbox" (change)="setBilling($event)" />
                  <span>Billing same as service address?</span>
                </label>
              </div>

              <div class="form-group">
                <label>Address *</label>
                <input type="text" formControlName="billing-address" class="form-input" [disabled]="isChecked" />
                <small class="error-text"
                  *ngIf="customerInfoForm.get('billing-address')?.touched && customerInfoForm.get('billing-address')?.invalid">
                  Required.
                </small>
              </div>

              <div class="form-group">
                <label>Line 2</label>
                <input type="text" formControlName="billing-address2" class="form-input" [disabled]="isChecked" />
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>City *</label>
                  <input type="text" formControlName="billing-city" class="form-input" [disabled]="isChecked" />
                  <small class="error-text"
                    *ngIf="customerInfoForm.get('billing-city')?.touched && customerInfoForm.get('billing-city')?.invalid">
                    Required.
                  </small>
                </div>
                <div class="form-group">
                  <label>State *</label>
                  <select formControlName="billing-state" class="form-select" [disabled]="isChecked">
                    <option value="">Select state</option>
                    <option *ngFor="let state of states" [value]="state.abbr">{{ state.name }} – {{ state.abbr }}
                    </option>
                  </select>
                  <small class="error-text"
                    *ngIf="customerInfoForm.get('billing-state')?.touched && customerInfoForm.get('billing-state')?.invalid">
                    Required.
                  </small>
                </div>
                <div class="form-group">
                  <label>ZIP *</label>
                  <input type="text" formControlName="billing-zip" class="form-input" maxlength="10"
                    [disabled]="isChecked" />
                  <small class="error-text"
                    *ngIf="customerInfoForm.get('billing-zip')?.touched && customerInfoForm.get('billing-zip')?.invalid">
                    Required.
                  </small>
                </div>
              </div>

              <input type="text" formControlName="honeypot" class="honeypot-input" autocomplete="off" tabindex="-1"
                aria-hidden="true" />

              <div class="actions">
                <button type="submit" class="btn btn-primary" [disabled]="customerInfoForm.invalid || isLoading">
                  Next step
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- PIN STEP -->
        <div *ngSwitchCase="'pin'" class="step-content">
          <section class="hero">
            <h1>Two Factor Authentication</h1>
            <p>Keep your account safe</p>
          </section>

          <div class="form-section">
            <p>Create a second step when you sign in.</p>

            <div class="button-group">
              <button type="button" class="btn btn-primary" [disabled]="otpEmailCooldown > 0"
                (click)="sendOTP('email')">
                {{ otpEmailCooldown ? 'Resend Code by Email (' + otpEmailCooldown + 's)' : 'Send Code by Email' }}
              </button>
              <button type="button" class="btn btn-primary" [disabled]="otpSmsCooldown > 0" (click)="sendOTP('sms')">
                {{ otpSmsCooldown ? 'Resend Code by Text (' + otpSmsCooldown + 's)' : 'Send Code by Text' }}
              </button>
            </div>

            <p class="success-text" *ngIf="deliveryMessage">{{ deliveryMessage }}</p>

            <div class="form-group" *ngIf="pinModalOpen">
              <label>Enter Code</label>
              <input type="tel" [(ngModel)]="pinInput" class="form-input" maxlength="8" />
            </div>

            <button type="button" class="btn btn-success" [disabled]="!pinInput" (click)="confirmPin()">
              Verify Code
            </button>
          </div>
        </div>

        <!-- WALLET STEP -->
        <div *ngSwitchCase="'wallet'" class="step-content">
          <div *ngIf="!shouldSkipWallet" class="form-section">
            <section class="hero">
              <h1>Wallet Setup</h1>
              <p>A message will be sent to the customer to enter and save their payment method.</p>
            </section>

            <p>Please select the delivery format:</p>

            <div class="button-group">
              <button type="button" class="btn btn-primary"
                [disabled]="!walletForm.get('email')?.value || walletForm.get('email')?.invalid || walletEmailCooldown > 0"
                (click)="sendPaymentMessage('SendEmail')">
                {{ walletEmailCooldown ? 'Resend Link by Email (' + walletEmailCooldown + 's)' : 'Send Link by Email' }}
              </button>
              <button type="button" class="btn btn-primary"
                [disabled]="walletForm.get('phone')?.invalid || walletSmsCooldown > 0"
                (click)="sendPaymentMessage('SendSms')">
                {{ walletSmsCooldown ? 'Resend Link by Text (' + walletSmsCooldown + 's)' : 'Send Link by Text' }}
              </button>
            </div>

            <p class="success-text" *ngIf="displayText">{{ displayText }}</p>

            <button type="button" class="btn btn-success" [disabled]="!showVerifyButton" (click)="checkPayment()">
              Verify Payment
            </button>
          </div>
        </div>

        <!-- TIME SLOTS STEP -->
        <div *ngSwitchCase="'time'" class="step-content">
          <section class="hero">
            <h1>Select a time slot</h1>
            <p>Pick an available date to see the installation windows for that day.</p>
          </section>

          <div class="form-section">
            <div *ngIf="limitedDates?.length; else noDates">
              <div class="form-group">
                <label>Select an available date</label>
                <select [(ngModel)]="selectedDate" (change)="getBookings(selectedDate)" class="form-select">
                  <option *ngFor="let date of limitedDates" [value]="date">
                    {{ date | date:'EEEE MM/dd/yyyy' }}
                  </option>
                </select>
              </div>

              <div *ngIf="selectedDate && groupedTimeSlots[selectedDate]?.length; else noSlots">
                <div class="section-header">
                  <h3>{{ selectedDate | date:'EEEE MM/dd/yyyy' }}</h3>
                </div>

                <div class="time-slots-list">
                  <label *ngFor="let slot of groupedTimeSlots[selectedDate]" class="time-slot-item">
                    <input type="radio" name="timeSlot" [value]="slot" [checked]="selectedTimeSlot === slot"
                      (change)="selectTimeSlot(slot)" />
                    <span>{{ slot.label }}</span>
                  </label>
                </div>
              </div>

              <ng-template #noSlots>
                <p class="info-text">No time slots available for {{ selectedDate | date:'EEEE MM/dd/yyyy' }}. Pick
                  another date.</p>
              </ng-template>
            </div>

            <ng-template #noDates>
              <p class="info-text">No installation times are currently available.</p>
            </ng-template>
          </div>
        </div>

        <!-- REVIEW STEP -->
        <div *ngSwitchCase="'review'" class="step-content">
          <section class="hero">
            <h1>Review & submit</h1>
            <p>Please confirm everything looks right before placing the order.</p>
          </section>

          <div class="form-section">
            <div class="section-header">
              <h3>Summary</h3>
            </div>

            <div class="summary-item" *ngIf="cartInfo?.primaryAccountHolderInfo?.businessName">
              <strong>Business Name</strong><br />
              {{ cartInfo.primaryAccountHolderInfo.businessName }}
            </div>

            <div class="summary-item">
              <strong>Customer</strong><br />
              {{ fullData?.customerInfo?.first }} {{ fullData?.customerInfo?.last }}
            </div>

            <div class="summary-item">
              <strong>Service address</strong><br />
              {{ fullData?.addressInfo?.fullAddress }}
            </div>

            <div class="summary-item" *ngIf="fullData?.selectedTime">
              <strong>Install date</strong><br />
              {{ fullData.selectedTime.selectedDate | date:'EEEE MM/dd/yyyy' }}
              at {{ fullData.selectedTime.startTime || 'TBD' }} – {{ fullData.selectedTime.endTime || 'TBD' }}
            </div>

            <div *ngIf="charges.length" class="section-header">
              <h3>Charges</h3>
            </div>
            <div *ngFor="let row of charges" class="summary-row">
              <span>{{ row.label }}</span>
              <span>{{ row.amount === 'Included' ? 'Included' : (row.amount | currency) }}</span>
            </div>

            <div *ngIf="discounts.length" class="section-header">
              <h3>Discounts</h3>
            </div>
            <div *ngFor="let row of discounts" class="summary-row">
              <span>{{ row.label }}</span>
              <span>-{{ row.amount | currency }}</span>
            </div>

            <div *ngIf="offers.length" class="section-header">
              <h3>Offers</h3>
            </div>
            <div *ngFor="let row of offers" class="summary-row">
              <span>{{ row.label }}</span>
              <span>{{ row.amount === 'Included' ? 'Included' : (row.amount | currency) }}</span>
            </div>

            <div class="final-price">
              <strong>Final price</strong>
              <strong>{{ finalPrice | currency }}</strong>
            </div>

            <div class="actions">
              <button type="button" class="btn btn-primary" (click)="submitReview()" [disabled]="isLoading">
                Submit order
              </button>
            </div>
          </div>

          <!-- Success Modal -->
          <div *ngIf="isModalOpen" class="modal-backdrop" (click)="modalControl('close')">
            <div class="modal" (click)="$event.stopPropagation()">
              <div class="modal-header">
                <h2>{{ fullData?.customerInfo?.first }} {{ fullData?.customerInfo?.last }} order created</h2>
                <button type="button" class="modal-close" (click)="modalControl('close')">&times;</button>
              </div>
              <div class="modal-body">
                <p>Let me recap your order, today you have chosen Fidium Fiber {{
                  fullData?.selectedInfo?.internetPlan?.productName || fullData?.selectedPlan?.planName }}.</p>
                <p>Order successfully created.</p>
                <p *ngIf="!isExistingFlow && orderNumber">Your order number is <strong>{{ orderNumber }}</strong>.</p>
                <p>Your monthly recurring charges will be {{ finalPrice | currency }} plus taxes and fees.</p>
                <p>All plans and pricing are for new customers and all promotional offers are for a limited time. There
                  is no contract or early termination fees for your internet or phone plans.</p>
                <p>On day of install you can expect:</p>
                <ul>
                  <li>Depending on your configuration, we may run fiber aerially or via a small trench. A temporary line
                    may be used until burial is completed.</li>
                  <li>We'll connect fiber to the outside of your property using a small box.</li>
                  <li>We may drill a small, sealed hole to bring fiber inside to the ONT and gateway.</li>
                </ul>
                <p>Wireless speeds can vary based on device, distance, number of devices, and interference.</p>
                <p>An adult (18+) must be present at install.</p>
                <p>Please wait 24 hours for processing before adjusting your order.</p>
                <p>Do not cancel your current provider until Fidium service is active.</p>
                <p>Support: 844-434-3486.</p>
                <p>Complete registration from your confirmation email. You can enroll in auto-pay for a $2.50 discount
                  (already reflected in your quote).</p>
                <p>We'll keep you updated by text with confirmations, reminders, on-the-way, and completion notices.</p>
                <p>The $199.00 installation fee was waived today.</p>
                <p>Anything else I can help with?</p>
                <p>Welcome to Fidium!</p>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
    </div>
  </div>

  <!-- Error Modal -->
  <div *ngIf="error" class="error-modal-backdrop" (click)="dismissError()">
    <div class="error-modal" (click)="$event.stopPropagation()">
      <div class="error-modal-header">
        <h2>Oops! Something went wrong</h2>
      </div>
      <div class="error-modal-body">
        <p>{{ errorText || "We encountered an issue while processing your request. Please try again later." }}</p>
        <p>We're here to help! If you have any questions or need support, don't hesitate to reach out to us.</p>
        <p><strong>Call us:</strong> +1 (855) 681-4644</p>
      </div>
      <div class="error-modal-footer">
        <button type="button" class="btn btn-primary" (click)="dismissError()">Okay</button>
      </div>
    </div>
  </div>

  <!-- Help Link -->
  <div class="link-div">
    <a class="link-text" (click)="infoModal('open')">Need Assistance? Contact Us</a>
  </div>

  <!-- Info Modal -->
  <div *ngIf="infoModalOpen" class="modal-backdrop" (click)="infoModal('close')">
    <div class="modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Need Assistance?</h2>
        <button type="button" class="modal-close" (click)="infoModal('close')">&times;</button>
      </div>
      <div class="modal-body">
        <p>We're here to help! If you have any questions or need support, don't hesitate to reach out to us.</p>
        <p><strong>Call us:</strong> +1 (855) 681-4644</p>
        <p>Our support team is available Monday through Friday, 9 AM - 5 PM (MT).</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="infoModal('close')">Close</button>
      </div>
    </div>
  </div>

  <!-- Pre-Order Modal -->
  <div *ngIf="preOrderModalOpen" class="modal-backdrop" (click)="closePreOrderModal()">
    <div class="modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Pre-Order Required</h2>
        <button type="button" class="modal-close" (click)="closePreOrderModal()">&times;</button>
      </div>
      <div class="modal-body">
        <p>This address requires a pre-order. Please call us to complete your order.</p>
        <p>Support: 844-434-3486</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="closePreOrderModal()">Close</button>
      </div>
    </div>
  </div>
</div>